import { BehaviorSubject, Observable, of, map, shareReplay, switchMap, take } from 'rxjs';

export class DataLoader<T> {
  private observable: Observable<T>;

  private cache: BehaviorSubject<T> = new BehaviorSubject(null);

  private accessing: Observable<T> = null;

  private options: any = null;

  constructor(
    private accessor: (val?: any) => Observable<T>,
    private log?: boolean,
  ) {
    this.observable = this.cache.asObservable().pipe(
      switchMap(value => {
        // si on a une valeur en cache on la retourne
        if (value) {
          if (this.log) console.debug('from cache', value);
          return of(value);
        }

        // si ce n'est pas fait on lance le chargement
        if (!this.accessing) {
          this.accessing = accessor(this.options).pipe(
            shareReplay(1),
            switchMap((data: T) => {
              this.cache.next(data);
              return of(data);
            }),
          );
          if (this.log) console.debug('make the call', this.accessing);
        }

        // on renvoie le chargment en court
        if (this.log) console.debug('return the call observer', this.accessing);
        return this.accessing;
      }),
    );
  }

  /**
   * Flux VIF : ne complète jamais, ré-émet après reset().
   * Pour les lectures one-shot, utiliser current$().
   */
  get(options?: any): Observable<T> {
    this.options = options;
    return this.observable;
  }

  /**
   * Lecture one-shot : valeur courante (fetch si nécessaire), puis complète.
   * Pour les resolvers, snapshots et lectures internes aux chaînes d'écriture.
   *
   * Pas de filter sur null : DataLoaderAuthentified émet légitimement null
   * quand l'utilisateur n'est pas authentifié, et un resolver qui ne complète
   * jamais gèle la navigation pour de bon (le Router applique first(), sans
   * timeout).
   */
  current$(options?: any): Observable<T> {
    return this.get(options).pipe(take(1));
  }

  reset(): Observable<T> {
    this.accessing = null;
    this.cache.next(null);
    return this.get();
  }

  setCache(entity: T): void {
    this.cache.next(entity);
  }
}
